document.addEventListener('DOMContentLoaded' , () =>{
    // community - overseas-shop-page
    if(document.querySelector('.overseas-shop-page')){
        const btnCountry = document.querySelectorAll('.country_tit');

        function openCountry(e){
            const btnCountryLi =e.target.parentNode.parentNode;
            const hasClassOn = btnCountryLi.classList.contains('on');

            if(hasClassOn){
                btnCountryLi.classList.remove('on');
            }else{
                document.querySelectorAll('.continent_list>li').forEach((el) => {
                    el.classList.remove('on')
                });
                btnCountryLi.classList.add('on');
            }
        }

        btnCountry.forEach((el) => {
            el.addEventListener('click', openCountry)
        });
    };
});
